<!-- TOOLBAR -->
<div class="ite-toolbar" #toolbar [attr.data-theme]="'light'" (click)="$event.stopPropagation();">

  <!-- ZMIEŃ ZDJĘCIE -->
  <input #changeImgInput type="file" accept="image/*" hidden (change)="replaceImage(changeImgInput.files!)"/>
  <button class="btn-change" (click)="changeImgInput.click(); $event.stopPropagation(); $event.preventDefault();">
    <img src="assets/icons/image.svg" alt="" (change)="replaceImage(changeImgInput.files!)"
         (click)="$event.stopPropagation(); $event.preventDefault()"/><span>{{ "creator.changePhoto" | translate }}</span>
  </button>

  <div class="distributor"></div>

  <!-- USUŃ LINK Z OBRAZKA -->
  <button type="button" title="Usuń link" (click)="onUnlink(); $event.stopPropagation(); $event.preventDefault()">
    <img src="assets/icons/link-off.svg" alt=""/>
  </button>

  <div class="distributor"></div>

  <!-- DODAJ LINK (URL / mailto) -->
  <button (click)="applyCommand(); $event.stopPropagation(); $event.preventDefault()">
    <img src="assets/icons/link.svg" alt=""/>
  </button>

  <div class="distributor"></div>

  <!-- EDYTUJ ALT TEKST -->
  <button type="button" class="btn-alt" (click)="onEditAlt(); $event.stopPropagation(); $event.preventDefault()">
    <span>{{ "creator.editAltText" | translate }}</span>
  </button>
</div>

<!-- OBSZAR EDYCJI -->
<div
  [attr.data-theme]="'dark'"
  class="ite-editor"
  contenteditable="true"
  #editable
  [innerHTML]="innerHtmlSafe">
</div>
